// Action Types
const TOGGLE_ZONE = "TOGGLE_ZONE";

const initialState: any = {
  show_zones: false,
};

// Reducer
export function showZones(
  state = initialState,
  action: { type: any; payload: any }
) {
  switch (action.type) {
    case TOGGLE_ZONE:
      return {
        ...state,
        show_zones: !state.show_zones,
      };

    default:
      return state;
  }
}

// Action Creators
export function toggleShowZones() {
  return { type: TOGGLE_ZONE };
}
